import React from 'react'

import { Row, Col } from 'react-bootstrap'

import { Loading } from '../../components/shared'

import { commifyNumber } from '../../utils/utilities'

import './total-premium.scss'

export default function TotalPremium({ isModified, surcharge, totalPremium, manuallySetPricing, onBlurHandler, selectedBaseCoverage }) {
  if (!totalPremium && !manuallySetPricing) return null
  
  return (
    <Row>
      <Col xs={8} md={6}>
      <div className="total-premium-main">
        <div className="total-premium-row">
          <div className="h4" style={{fontSize: '16px'}}>Total Cost</div>
          <div className="text-success h1">
            {
              isModified
              ? <Loading width="47px" height="47px" />
              : <span>${commifyNumber(totalPremium || 0)}</span> 
            }
          </div>
        </div>
        {(selectedBaseCoverage === 'deductibleWarranty' && surcharge > 0) && <b style={{color: 'black'}}>Total cost includes a ${surcharge} loss control surcharge</b>}
        </div>
      </Col>
    </Row>
  );
}
